;(function (window, document, $) {
    'use strict';

    $(document).ready(function () {
        let ajaxLockActive = false;
        let quillObj = null;
        let editModal = null;
        let unsavedConfirmModal = null;
        let allowEditorClose = false;
        const supportedLanguageCodes = ['NO', 'EN', 'SE'];
        let activeLanguageCode = 'NO';
        let languageDrafts = getEmptyLanguageDrafts();
        let initialLanguageDrafts = getEmptyLanguageDrafts();

        function getEmptyLanguageDrafts() {
            return {NO: '', EN: '', SE: ''};
        }

        function getCurrentInterfaceLanguage() {
            const languageSelector = document.getElementById('language-selector');
            const language = languageSelector
                ? String(languageSelector.getAttribute('data-current-language') || '').toUpperCase()
                : 'NO';

            return supportedLanguageCodes.indexOf(language) !== -1 ? language : 'NO';
        }

        function normalizeEditorContent(content) {
            const contentWrapper = $('<div></div>').html(content || '');
            contentWrapper.find('img').css({'max-width': '100%', 'height': 'auto'});
            const normalizedContent = contentWrapper.html() || '';

            return normalizedContent === '<p><br></p>' || normalizedContent === '<p></p>'
                ? ''
                : normalizedContent;
        }

        function hasMeaningfulContent(html) {
            const wrapper = $('<div></div>').html(html || '');
            return $.trim(wrapper.text()) !== '' || wrapper.find('img,video,audio,iframe,object,embed,svg').length > 0;
        }

        function readLanguageDrafts() {
            const drafts = getEmptyLanguageDrafts();
            $('.admin-settings-description-language-data', document).each(function () {
                const languageCode = $(this).attr('data-language-code');
                if (supportedLanguageCodes.indexOf(languageCode) !== -1) {
                    drafts[languageCode] = $(this).val() || '';
                }
            });
            return drafts;
        }

        function captureActiveLanguageDraft() {
            if (quillObj && supportedLanguageCodes.indexOf(activeLanguageCode) !== -1) {
                languageDrafts[activeLanguageCode] = normalizeEditorContent(quillObj.root.innerHTML);
            }
        }

        function updateActiveLanguageButton() {
            $('.admin-settings-description-language-btn', document).each(function () {
                const button = $(this);
                const isActive = button.attr('data-language-code') === activeLanguageCode;
                button.toggleClass('btn-primary', isActive)
                    .toggleClass('btn-default', !isActive)
                    .attr('aria-pressed', isActive ? 'true' : 'false');
            });
            $('.admin-settings-description-language-hint [data-language-code]', document).each(function () {
                $(this).prop('hidden', $(this).attr('data-language-code') !== activeLanguageCode);
            });
        }

        function setActiveLanguage(languageCode) {
            if (!quillObj || supportedLanguageCodes.indexOf(languageCode) === -1 || languageCode === activeLanguageCode) {
                return;
            }

            captureActiveLanguageDraft();
            activeLanguageCode = languageCode;
            quillObj.root.innerHTML = languageDrafts[languageCode] || '';
            updateActiveLanguageButton();
            quillObj.focus();
        }

        function getHelpButtons(pageKey, elementKey) {
            return $('.admin-settings-description-help-btn', document).filter(function () {
                return $(this).attr('data-page-key') === pageKey
                    && $(this).attr('data-element-key') === elementKey;
            });
        }

        function getTooltipTemplate(helpButton) {
            const tooltipId = helpButton.attr('data-admin-settings-description-tooltip');
            return tooltipId ? $('#' + tooltipId, document) : $();
        }

        function cancelPopoverHide(helpButton) {
            window.clearTimeout(helpButton.data('admin-settings-description-hide-timer'));
            helpButton.removeData('admin-settings-description-hide-timer');
        }

        function schedulePopoverHide(helpButton) {
            cancelPopoverHide(helpButton);
            helpButton.data('admin-settings-description-hide-timer', window.setTimeout(function () {
                if (helpButton.data('admin-settings-description-mode') === 'hover') {
                    hidePopover(helpButton);
                }
            }, 200));
        }

        function hidePopover(helpButton) {
            if (!helpButton || !helpButton.length) {
                return;
            }

            cancelPopoverHide(helpButton);
            try {
                helpButton.popover('destroy');
            } catch (error) {
                // The popover may not have been initialized yet.
            }
            helpButton.attr('aria-expanded', 'false').removeClass('is-open').removeData('admin-settings-description-mode');
        }

        function hideAllPopovers(exceptButton) {
            $('.admin-settings-description-help-btn', document).each(function () {
                if (!exceptButton || this !== exceptButton[0]) {
                    hidePopover($(this));
                }
            });
        }

        function repositionPopoverAfterImageLoad(helpButton, popover) {
            const popoverInstance = helpButton.data('bs.popover');
            if (!popover.length || !popover.hasClass('in') || !popoverInstance) {
                return;
            }

            const placement = ['top', 'bottom', 'left', 'right'].filter(function (className) {
                return popover.hasClass(className);
            })[0] || 'top';
            const position = popoverInstance.getPosition();
            const offset = popoverInstance.getCalculatedOffset(
                placement,
                position,
                popover[0].offsetWidth,
                popover[0].offsetHeight
            );

            popoverInstance.applyPlacement(offset, placement);
        }

        function preparePopoverImages(helpButton, popover) {
            const images = popover.find('.admin-settings-description-tooltip-content img');
            let repositionScheduled = false;

            function scheduleReposition() {
                if (repositionScheduled) {
                    return;
                }

                repositionScheduled = true;
                window.requestAnimationFrame(function () {
                    repositionScheduled = false;
                    repositionPopoverAfterImageLoad(helpButton, popover);
                });
            }

            images
                .css({display: 'block', visibility: 'visible', 'max-width': '100%', height: 'auto'})
                .one('load.adminSettingsDescription error.adminSettingsDescription', scheduleReposition)
                .each(function () {
                    if (this.complete) {
                        scheduleReposition();
                    }
                });
        }

        function showPopover(helpButton, mode) {
            const template = getTooltipTemplate(helpButton);
            if (!template.length) {
                return;
            }

            const descriptionHtml = template.find('.admin-settings-description-tooltip-content').html() || '';
            if (mode === 'hover' && !hasMeaningfulContent(descriptionHtml)) {
                return;
            }

            hideAllPopovers(helpButton);
            hidePopover(helpButton);
            const popoverModeClass = mode === 'click'
                ? 'admin-settings-description-popover-click'
                : 'admin-settings-description-popover-hover';
            helpButton.popover({
                container: 'body',
                placement: 'auto top',
                trigger: 'manual',
                html: true,
                template: '<div class="popover admin-settings-description-popover '
                    + popoverModeClass
                    + '" role="tooltip"><div class="arrow"></div>'
                    + '<h3 class="popover-title"></h3><div class="popover-content"></div></div>',
                title: mode === 'click' ? (helpButton.attr('data-element-label') || '') : '',
                content: mode === 'click' ? template.html() : descriptionHtml
            });
            helpButton.data('admin-settings-description-mode', mode).toggleClass('is-open', mode === 'click');
            helpButton.popover('show').attr('aria-expanded', 'true');
            const popoverInstance = helpButton.data('bs.popover');
            const popover = popoverInstance ? popoverInstance.tip() : $();
            if (mode === 'hover') {
                popover.on('mouseenter.adminSettingsDescription', function () {
                    cancelPopoverHide(helpButton);
                }).on('mouseleave.adminSettingsDescription', function () {
                    schedulePopoverHide(helpButton);
                });
            }
            preparePopoverImages(helpButton, popover);
        }

        function loadTooltipContent(helpButton, onComplete) {
            const pageKey = helpButton.attr('data-page-key');
            const elementKey = helpButton.attr('data-element-key');
            const template = getTooltipTemplate(helpButton);

            if (!pageKey || !elementKey || !template.length) {
                return;
            }

            if (template.attr('data-loaded') === '1') {
                onComplete();
                return;
            }

            const activeRequest = template.data('admin-settings-description-request');
            if (activeRequest) {
                activeRequest.always(onComplete);
                return;
            }

            template.attr('data-loading', '1');
            const request = $.ajax({
                type: 'GET',
                url: '/action/admin-settings-description/'
                    + encodeURIComponent(pageKey) + '/'
                    + encodeURIComponent(elementKey) + '/tooltip',
                data: {language: getCurrentInterfaceLanguage()},
                dataType: 'html'
            }).done(function (html) {
                template.find('.admin-settings-description-tooltip-content').html(
                    normalizeEditorContent(html)
                );
                template.attr('data-loaded', '1');
            }).fail(function () {
                template.find('.admin-settings-description-tooltip-content').text(
                    getCurrentInterfaceLanguage() === 'EN'
                        ? 'The help text could not be loaded.'
                        : 'Kunne ikke hente hjelpeteksten.'
                );
            }).always(function () {
                template.attr('data-loading', '0');
                template.removeData('admin-settings-description-request');
                onComplete();
            });

            template.data('admin-settings-description-request', request);
        }

        window.initAdminSettingsDescriptionTooltips = function (selector) {
            const tooltipSelector = selector || '.admin-settings-description-help-btn';
            $(tooltipSelector, document).each(function () {
                const helpButton = $(this);
                if (helpButton.attr('data-admin-settings-description-initialized') === '1') {
                    return;
                }

                let hoverTimer = null;
                helpButton.on('mouseenter.adminSettingsDescription', function () {
                    cancelPopoverHide(helpButton);
                    if (helpButton.data('admin-settings-description-mode')) {
                        return;
                    }
                    hoverTimer = window.setTimeout(function () {
                        if (helpButton.data('admin-settings-description-mode') === 'click') {
                            return;
                        }
                        loadTooltipContent(helpButton, function () {
                            if (helpButton.is(':hover') && helpButton.data('admin-settings-description-mode') !== 'click') {
                                showPopover(helpButton, 'hover');
                            }
                        });
                    }, 0);
                });
                helpButton.on('mouseleave.adminSettingsDescription', function () {
                    window.clearTimeout(hoverTimer);
                    if (helpButton.data('admin-settings-description-mode') === 'hover') {
                        schedulePopoverHide(helpButton);
                    }
                });
                helpButton.on('click.adminSettingsDescription', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    window.clearTimeout(hoverTimer);
                    loadTooltipContent(helpButton, function () {
                        showPopover(helpButton, 'click');
                    });
                });
                helpButton.attr('data-admin-settings-description-initialized', '1');
            });
        };

        $(document).on('click', '.admin-settings-description-close-tooltip-btn', function (event) {
            event.preventDefault();
            event.stopPropagation();
            getHelpButtons($(this).attr('data-page-key'), $(this).attr('data-element-key')).each(function () {
                hidePopover($(this));
            });
        });

        $(document).on('click', '.admin-settings-description-open-modal-btn', function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (ajaxLockActive) {
                return false;
            }

            const editButton = $(this);
            const pageKey = editButton.attr('data-page-key');
            const pageName = editButton.attr('data-page-name');
            const elementKey = editButton.attr('data-element-key');
            const helpButton = getHelpButtons(pageKey, elementKey).first();
            hideAllPopovers();

            ajaxLockActive = true;
            $.ajax({
                type: 'GET',
                url: '/action/admin-settings-description/'
                    + encodeURIComponent(pageKey) + '/'
                    + encodeURIComponent(elementKey),
                dataType: 'html'
            }).done(function (html) {
                $('#admin_settings_description_edit_help_modal, #admin_settings_description_unsaved_confirm_modal').remove();
                $('body').append(html);
                $('#admin_settings_description_modal_title').text(helpButton.attr('data-element-label') || '');
                $('#admin_settings_description_modal_save_btn').attr(
                    'data-page-name',
                    pageName || helpButton.attr('data-page-name') || ''
                );
                initEditModal();
            }).fail(function () {
                window.alert(getCurrentInterfaceLanguage() === 'EN'
                    ? 'The help editor could not be loaded.'
                    : 'Kunne ikke hente editoren for hjelpeteksten.');
            }).always(function () {
                ajaxLockActive = false;
            });

            return false;
        });

        $(document).on('click', '.admin-settings-description-language-btn', function () {
            setActiveLanguage($(this).attr('data-language-code'));
            return false;
        });

        $(document).on('click', '#admin_settings_description_modal_save_btn', function () {
            const saveButton = $(this);
            const pageKey = saveButton.attr('data-page-key');
            const pageName = saveButton.attr('data-page-name');
            const elementKey = saveButton.attr('data-element-key');

            if (!pageKey || !pageName || !elementKey || !quillObj || ajaxLockActive) {
                return false;
            }

            captureActiveLanguageDraft();
            ajaxLockActive = true;
            saveButton.prop('disabled', true);
            $('#admin_settings_description_modal_alert').attr('hidden', true);

            $.ajax({
                type: 'POST',
                url: '/action/admin-settings-description/'
                    + encodeURIComponent(pageKey) + '/'
                    + encodeURIComponent(elementKey),
                data: {page_name: pageName, descriptions: languageDrafts},
                dataType: 'json'
            }).done(function () {
                const interfaceLanguage = getCurrentInterfaceLanguage();
                getHelpButtons(pageKey, elementKey).each(function () {
                    const helpButton = $(this);
                    const template = getTooltipTemplate(helpButton);
                    template.find('.admin-settings-description-tooltip-content').html(languageDrafts[interfaceLanguage] || '');
                    template.attr('data-loaded', '1');
                });

                initialLanguageDrafts = $.extend({}, languageDrafts);
                allowEditorClose = true;
                editModal.modal('hide');
                showSaveStatus();
            }).fail(function (xhr) {
                let message = getCurrentInterfaceLanguage() === 'EN'
                    ? 'The help text could not be saved.'
                    : 'Kunne ikke lagre hjelpeteksten.';
                if (xhr.responseJSON && xhr.responseJSON.errors) {
                    message = Array.isArray(xhr.responseJSON.errors)
                        ? xhr.responseJSON.errors.join('<br>')
                        : xhr.responseJSON.errors;
                }
                $('#admin_settings_description_modal_alert')
                    .removeClass('alert-success')
                    .addClass('alert-danger')
                    .html(message)
                    .removeAttr('hidden');
            }).always(function () {
                ajaxLockActive = false;
                saveButton.prop('disabled', false);
            });

            return false;
        });

        $(document).on('click', '.admin-settings-description-modal-close-btn', function (event) {
            event.preventDefault();
            if (editModal) {
                editModal.modal('hide');
            }
            return false;
        });

        $(document).on('click', '.admin-settings-description-continue-editing-btn', function () {
            if (unsavedConfirmModal) {
                unsavedConfirmModal.modal('hide');
            }
            return false;
        });

        $(document).on('click', '.admin-settings-description-discard-changes-btn', function () {
            if (!unsavedConfirmModal || !editModal || ajaxLockActive) {
                return false;
            }

            allowEditorClose = true;
            unsavedConfirmModal.modal('hide');
            editModal.modal('hide');
            return false;
        });

        $(document).on('click', function (event) {
            if (!$(event.target).closest('.admin-settings-description-help-btn, .admin-settings-description-popover').length) {
                hideAllPopovers();
            }
        });

        function hasUnsavedEditorChanges() {
            if (!quillObj) {
                return false;
            }

            captureActiveLanguageDraft();
            return supportedLanguageCodes.some(function (languageCode) {
                return normalizeEditorContent(languageDrafts[languageCode])
                    !== normalizeEditorContent(initialLanguageDrafts[languageCode]);
            });
        }

        function initEditModal() {
            editModal = $('#admin_settings_description_edit_help_modal');
            unsavedConfirmModal = $('#admin_settings_description_unsaved_confirm_modal');
            if (!editModal.length || !unsavedConfirmModal.length || typeof Quill !== 'function') {
                window.alert('Quill could not be loaded.');
                return;
            }

            allowEditorClose = false;
            languageDrafts = readLanguageDrafts();
            activeLanguageCode = getCurrentInterfaceLanguage();
            initialLanguageDrafts = $.extend({}, languageDrafts);
            quillObj = new Quill('#admin_settings_description_editor', {
                theme: 'snow',
                bounds: '#admin_settings_description_editor',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['link', 'image'],
                        [{list: 'ordered'}, {list: 'bullet'}],
                        [{indent: '-1'}, {indent: '+1'}],
                        [{size: ['small', false, 'large', 'huge']}],
                        [{header: [1, 2, 3, 4, 5, 6, false]}],
                        [{color: []}, {background: []}],
                        [{font: []}],
                        [{align: []}],
                        ['clean']
                    ]
                }
            });
            quillObj.root.innerHTML = languageDrafts[activeLanguageCode] || '';
            updateActiveLanguageButton();

            editModal.on('hide.bs.modal.adminSettingsDescription', function (event) {
                if (!allowEditorClose && !ajaxLockActive && hasUnsavedEditorChanges()) {
                    event.preventDefault();
                    unsavedConfirmModal.modal({backdrop: 'static', keyboard: false, show: true});
                }
            });
            editModal.on('shown.bs.modal.adminSettingsDescription', function () {
                $('.modal-backdrop').last().addClass('admin-settings-description-edit-backdrop');
            });
            editModal.on('hidden.bs.modal.adminSettingsDescription', function () {
                const modal = editModal;
                const confirmModal = unsavedConfirmModal;
                quillObj = null;
                editModal = null;
                unsavedConfirmModal = null;
                modal.remove();
                confirmModal.remove();
            });
            unsavedConfirmModal.on('shown.bs.modal.adminSettingsDescription', function () {
                $('.modal-backdrop').last().addClass('admin-settings-description-confirm-backdrop');
            });
            unsavedConfirmModal.on('hidden.bs.modal.adminSettingsDescription', function () {
                if (editModal && editModal.hasClass('in')) {
                    $('body').addClass('modal-open');
                }
            });

            editModal.modal({backdrop: true, keyboard: false, show: true});
        }

        function showSaveStatus() {
            const message = getCurrentInterfaceLanguage() === 'EN' ? 'Saved!' : 'Lagret!';
            const toast = $('<div class="alert alert-success admin-settings-description-save-toast" role="status"></div>')
                .text(message)
                .appendTo('body');
            window.setTimeout(function () {
                toast.fadeOut(200, function () {
                    toast.remove();
                });
            }, 1800);
        }

        window.initAdminSettingsDescriptionTooltips();
    });
})(window, document, window.jQuery);
